export const uiZh = {
  'app.skipLink': '跳到主要內容',
  'app.home': 'Atlas 首頁',
  'app.mainMenu': '主要選單',
  'nav.value': '價值排行',
  'nav.status': '資料狀態',
  'topbar.verified': '資料核驗',
  'error.service': '服務暫時無法使用',
  'error.load': '資料暫時無法載入',
  'error.unreachable': '資料服務暫時無法連線',
  'error.keepFresh': '；只保留仍在有效期限內的結果。',
  'error.retry': '重試',
  'app.loading': '資料載入中…',
  'unknown.free': '免費方案，不以無限倍排行',
  'unknown.nousage': '尚無可靠用量，保留方案與來源',
  'toast.maxCompare': '一次最多比較 3 個情境',
  'footer.method': '比較方式與資料邊界',
  'footer.sources': '資料來源：',
  'tray.selected': '{n} / 3 已選',
  'tray.remove': '移除 {label}',
  'tray.compare': '比較 →',
  'tray.clear': '清空比較',
  'filter.aria': '比較設定',
  'filter.preference': '偏好',
  'filter.balanced': '兼顧能力與價格',
  'filter.valueOnly': '只看價格',
  'filter.category': '分類',
  'filter.all': '全部',
  'filter.coding': 'Coding',
  'filter.webdev': 'WebDev',
  'filter.frontend': 'Frontend',
  'filter.advanced': '進階篩選',
  'filter.search': '搜尋方案／模型',
  'filter.searchPlaceholder': '例如 GLM、OpenCode',
  'filter.budget': '每月付款上限 · USD',
  'filter.upfront': '首次付款上限 · USD',
  'filter.any': '不限',
  'filter.provider': '通路',
  'filter.allProviders': '全部通路',
  'filter.ability': '能力參考',
  'filter.anyRank': '不限名次',
  'filter.top10': '前 10 名',
  'filter.top20': '前 20 名',
  'filter.top50': '前 50 名',
  'filter.tokenProfile': 'Token 情境',
  'filter.standard': '一般使用 · 不計快取',
  'filter.cached': '重複輸入 · 80% 輸入快取',
  'filter.speed': '模型速度參考',
  'filter.anySpeed': '不限速度',
  'filter.speed50': '至少 50 tokens／秒',
  'filter.speed100': '至少 100 tokens／秒',
  'filter.billing': '付款方式',
  'filter.monthly': '月繳／按量',
  'filter.annual': '同時納入年繳',
  'filter.reset': '重設篩選',
  'filter.footnote': '綜合推薦以每美元可用量 60%、領域能力 40% 加權；優惠倍率保留原始研究比較。預算有上限時，最低付款未核實的方案會排除。',
  'list.aria': '每美元價值排行',
  'list.headingBalanced': '找到兼顧能力與每美元用量的方案。',
  'list.headingValue': '每一美元，換得多少 API 價值。',
  'list.methodBalanced': '推薦分數如何計算',
  'list.methodValue': '同模型官方 API = 1×',
  'list.updating': '正在更新結果',
  'sort.value': '價值',
  'sort.plan': '通路／方案／模型',
  'sort.rank': '能力排名',
  'sort.cost': '實付費用',
  'sort.conditions': '使用條件',
  'list.score': '推薦分數',
  'list.perDollar': '每 $1 的價值',
  'sort.asc': '升冪',
  'sort.desc': '降冪',
  'sort.none': '未排序',
  'cond.multiSourceDates': '多來源估算 · 日期差異',
  'cond.multiSourceN': '多來源估算 · {n} 個來源',
  'cond.originalResearch': '原始研究換算',
  'cond.officialBaseline': '同模型、同用量組成；已計入通路費用',
  'cond.goWindows': '每 5 小時／週／月限額',
  'cond.utilFull': '用滿',
  'cond.utilHalf': '用一半',
  'cond.utilQuarter': '用四分之一',
  'cond.utilWeeks': '{u} 4 週',
  'score.pendingSplit': '混合用量待拆分',
  'score.noBenchmark': '{v}× 等值 · 尚無對應評測',
  'score.multiplier': '{v}× {basis}',
  'score.points': '推薦 {v} 分',
  'score.estimate': '來源估算',
  'record.referenceOnly': '不計排行',
  'money.platform-budget': '內含平台金額',
  'money.api-observation': '社群 API 等值',
  'money.retail-credit-value': '按加購價計值',
  'money.unit-cost': '單位成本',
  'money.api-unit-cost': 'API 混合單價',
  'money.api-input-cost': 'API 輸入單價',
  'money.free': '免費用量，實付金額',
  'money.contract': '依合約及用量計算',
  'money.variable': '變動用量，尚缺金額實測',
  'money.unit.month': '每月',
  'money.unit.30 days': '每 30 天',
  'money.unit.million': '每百萬 tokens',
  'money.unit.input-million': '每百萬輸入 tokens',
  'money.unit.platform-million': '每百萬平台 tokens',
  'money.unit.credit': '每平台 credit',
  'money.unit.request': '每次請求',

  'record.referenceRatio': '原估算 {v}×（未採用）',
  'score.discount': '優惠',
  'list.officialApi': '官方 API',
  'list.usageBased': '按用量',
  'list.oneTime': '一次付清',
  'list.perMonth': ' / 月',
  'list.perYear': '年',
  'list.est': '估算',
  'list.empty': '目前沒有符合篩選條件的結果',
  'list.emptyHint': '可調整篩選；超過複查期限的資料保留在研究紀錄。',
  'list.clearFilters': '清除篩選',
  'list.loadingRows': '資料載入中',
  'score.notListed': '未收錄',
  'record.total': '{n} 個方案 · {scenarios} 個倍率情境',
  'record.review': '資料複查中',
  'record.ended': '已結束 · 保留原值',
  'record.waitlist': '既有訂戶／候補',
  'record.upcoming': '已公告方案',
  'record.variableQuota': '彈性額度',
  'record.apiRates': '每百萬 tokens：輸入 ${input}／輸出 ${output}',
  'record.view': '查看 {plan} {model} 完整資料',
  'record.note': '倍率比較每 $1 的 API 等值；分數綜合用量效率與模型能力。',
  'record.status': '資料狀態',

  'score.notPublished': '未公布',
  'score.noPublishedUsage': '未公布可換算用量',
  'pending.title': '既有方案與原始研究',
  'pending.count': '{n} 個方案，保留原始資料',
  'pending.intro': '此區完整保留原始價格、研究數字、來源及日期。包含待重新核驗及已由正式費率取代的原始研究；舊數字不冒充最新排行。',
  'pending.checked': '上次核對 {date}',
  'pending.price': '上次核對價格',
  'pending.research': '原始研究倍率',
  'research.historical': '歷史倍率',
  'research.reviewHistory': '歷次核對紀錄',
  'research.cachedRatio': '快取情境原始倍率',
  'research.cachedTokens': '快取情境原始用量（百萬 tokens）',
  'pending.view': '查看 {plan} 原始資料與來源',
  'unknown.title': '方案資料（尚無可靠倍率）',
  'unknown.more': '{names} 等 {n} 個',
  'unknown.intro': '價格、功能、模型與原始來源均保留；沒有可靠用量時不硬算倍率，免費方案也不寫成無限倍。',
  'list.free': '免費',
  'list.balancedNote': '每美元用量 60% × 能力 40% 的幾何加權。分數不是收益倍數；原始研究均保留。',
  'list.estimateNote': '* 多來源估算沿用原始研究，範圍與依據見彈窗。同套餐情境不可相加。',
  'list.scenarios': '{n} 個情境',
  'list.viewScenario': '查看 {plan} {model} {label}',
  'list.viewPlan': '查看 {plan}{models}',
  'dialog.method': '比較方式',
  'dialog.compare': '情境比較',
  'dialog.methodTitle': '一美元的價值，如何比較',
  'dialog.compareTitle': '把條件一起看清楚',
  'dialog.close': '關閉彈窗',
  'method.equivalent': '同模型 API 等值',
  'method.p1': '倍率 6×＝每付 $1，最多可用相當於官方 API $6 的同模型額度。這是價格倍率，不是能力或成果倍數。',
  'method.scoreLabel': '推薦分數',
  'method.scoreFormula': '100 × 用量百分位⁰·⁶ × 能力百分位⁰·⁴',
  'method.scoreNote': '用量＝每美元可用 Token 數，取全站百分位；能力＝榜單名次百分位。60/40 是公開取捨，不是唯一答案。',
  'method.rulesTitle': '同一把尺，公開條件',
  'method.rule1': '用量＝額度 ÷ 通路混合費率（80/20、不計快取）；篩選可切換快取情境。',
  'method.rule2': '能力＝Agent Arena 綜合榜名次百分位，取保守端；不同測試環境不混算。',
  'method.rule3': '訂閱以用滿額度上限估算，週額度保守換算 4 週；同套餐的模型與時段是替代情境，倍率不可相加。',
  'method.rule4': '多來源估算保留原始權重不重新推算；未核實活動、稅額與匯兌費不計。',
  'method.rule5': '分數只在同分類、同情境快照內比較；預算、搜尋與篩選不改變分數。',
  'method.footnote': '所有方案與研究持續顯示；複查期限只標記狀態，不刪除原數字。公式版本 official-equivalent-1。',
  'tabs.overview': '方案條件',
  'tabs.sources': '核驗來源',
  'tabs.planInfo': '方案資訊',
  'sources.userImport': '原研究檢查',
  'sources.fetched': '取得',
  'sources.note': '完整列出本筆資料的核驗來源；原始樣本、權重與換算方式可在方案條件中展開查看。',
  'detail.perDollar': '每花 $1',
  'detail.apiEquivalent': '${v} 同模型官方 API 等值',
  'detail.monthlyAmortized': '每月攤提',
  'detail.actualCost': '實付費用',
  'detail.byUsage': '按實際用量',
  'detail.apiInputRate': '輸入費率 · USD／百萬 tokens',
  'detail.apiOutputRate': '輸出費率 · USD／百萬 tokens',
  'detail.perMonthSuffix': ' / 月',
  'detail.annualUpfront': '年繳一次支付',
  'detail.utilization': '使用程度',
  'detail.usageBased': '按量使用',
  'detail.quotaPercent': '{n}% 額度',
  'detail.abilityRank': '能力排名',
  'detail.verifiedAt': '核驗時間',
  'detail.validUntil': '有效期限',
  'research.originalCheck': '原始檢查',
  'research.range': '原研究範圍 {lo}–{hi}× · 信度 {c}',
  'research.sourcesWeights': '研究來源與權重',
  'research.weight': '權重 {n}%',
  'research.monthlyEquivalent': '${v} / 月等值',
  'calc.basis': '換算依據',
  'calc.paid': '支付金額',
  'calc.usableQuota': '可用額度',
  'calc.totalTokens': '可用 Token 合計',
  'calc.apiEquivalent': '官方 API 等值',
  'calc.sameMix': '相同 Token 組合、相同模型。輸入 80%，輸出 20%；{cache}。{window}',
  'calc.cached': '輸入中 80% 命中快取',
  'calc.noCache': '不計快取',
  'calc.windowLimit': '受最緊的額度時窗限制。',
  'action.compare': '加入比較',
  'action.visitOfficial': '前往官方 ↗',
  'unknown.callout': '這個方案的價格與使用條件。',
  'unknown.listPrice': '公開牌價',
  'unknown.quotaNotes': '額度說明',
  'unknown.perYear': '年',
  'unknown.perMonth': '月',
  'dialog.sharedWarning': '這些情境有共用套餐，屬於不同使用方式，額度與倍率不能相加。',
  'status.title': '資料核驗紀錄',
  'status.publicJson': '查看公開 JSON ↗',
  'status.inDate': '期限內方案',
  'status.sources': '資料來源',
  'status.pendingRecheck': '待複查',
  'status.lastUpdated': '最後更新',
  'status.planSources': '方案來源與複查期限',
  'status.apiUsage': 'API 按量',
  'status.subFree': '訂閱／免費方案',
  'status.verified': '核驗',
  'status.inDateTag': '期限內',
  'status.recheckTag': '待複查',
  'status.viewSource': '查看來源 ↗',
  'bench.title': '模型評測',
  'bench.intro': '只比較同一榜單與測試方式，保留模型版本、來源和日期。',
  'bench.gotoBoard': '前往原始榜單 ↗',
  'bench.general': '綜合能力',
  'bench.empty': '這個分類尚無通過核驗的資料',
  'bench.frontendNote': 'Frontend 需要獨立分類來源，不直接套用 WebDev 的分數。',
  'bench.aaNote': 'Artificial Analysis 可提供 Coding 與綜合能力，資料接入後才會顯示。',
  'bench.rank': '來源名次',
  'bench.modelVersion': '模型／測試版本',
  'bench.score': '分數',
  'bench.tested': '評測日期',
  'bench.source': '來源',
  'bench.note': '榜單分數不代表實際供應通路的品質。推理強度、harness 與模型版本不同時，不能視為完全相同的服務。',
  'lang.switch': 'EN',
} as const;

export type UiKey = keyof typeof uiZh;

export const uiEn: Record<UiKey, string> = {
  'app.skipLink': 'Skip to main content',
  'app.home': 'Atlas home',
  'app.mainMenu': 'Main menu',
  'nav.value': 'Value ranking',
  'nav.status': 'Data status',
  'topbar.verified': 'Verified',
  'error.service': 'Service temporarily unavailable',
  'error.load': 'Data temporarily unavailable',
  'error.unreachable': 'Data service unreachable',
  'error.keepFresh': '; only in-date results are kept.',
  'error.retry': 'Retry',
  'app.loading': 'Loading…',
  'unknown.free': 'Free plan — not ranked at an infinite multiplier',
  'unknown.nousage': 'No reliable usage data — plan and sources preserved',
  'toast.maxCompare': 'Compare up to 3 scenarios at a time',
  'footer.method': 'Method & data boundaries',
  'footer.sources': 'Sources: ',
  'tray.selected': '{n} / 3 selected',
  'tray.remove': 'Remove {label}',
  'tray.compare': 'Compare →',
  'tray.clear': 'Clear comparison',
  'filter.aria': 'Comparison settings',
  'filter.preference': 'Preference',
  'filter.balanced': 'Balance ability & price',
  'filter.valueOnly': 'Price only',
  'filter.category': 'Category',
  'filter.all': 'All',
  'filter.coding': 'Coding',
  'filter.webdev': 'WebDev',
  'filter.frontend': 'Frontend',
  'filter.advanced': 'Advanced filters',
  'filter.search': 'Search plans/models',
  'filter.searchPlaceholder': 'e.g. GLM, OpenCode',
  'filter.budget': 'Monthly budget · USD',
  'filter.upfront': 'Upfront budget · USD',
  'filter.any': 'Any',
  'filter.provider': 'Provider',
  'filter.allProviders': 'All providers',
  'filter.ability': 'Ability reference',
  'filter.anyRank': 'Any rank',
  'filter.top10': 'Top 10',
  'filter.top20': 'Top 20',
  'filter.top50': 'Top 50',
  'filter.tokenProfile': 'Token profile',
  'filter.standard': 'Standard · no cache',
  'filter.cached': 'Repeated input · 80% cached',
  'filter.speed': 'Model speed reference',
  'filter.anySpeed': 'Any speed',
  'filter.speed50': 'At least 50 tok/s',
  'filter.speed100': 'At least 100 tok/s',
  'filter.billing': 'Billing',
  'filter.monthly': 'Monthly / usage',
  'filter.annual': 'Include annual',
  'filter.reset': 'Reset filters',
  'filter.footnote': 'Recommendations weight per-dollar usage 60% and domain ability 40%; promo multipliers keep the original research comparisons. With a budget cap, plans whose minimum payment is unverified are excluded.',
  'list.aria': 'Per-dollar value ranking',
  'list.headingBalanced': 'Plans that balance ability and per-dollar usage.',
  'list.headingValue': 'How much API value does each dollar buy?',
  'list.methodBalanced': 'How the score is computed',
  'list.methodValue': 'Same-model official API = 1×',
  'list.updating': 'Updating results',
  'sort.value': 'Value',
  'sort.plan': 'Provider / Plan / Model',
  'sort.rank': 'Ability rank',
  'sort.cost': 'Actual cost',
  'sort.conditions': 'Conditions',
  'list.score': 'Score',
  'list.perDollar': 'Monetary comparison',
  'sort.asc': 'Ascending',
  'sort.desc': 'Descending',
  'sort.none': 'Not sorted',
  'cond.multiSourceDates': 'Multi-source estimate · date variance',
  'cond.multiSourceN': 'Multi-source estimate · {n} sources',
  'cond.originalResearch': 'Original-research conversion',
  'cond.officialBaseline': 'Same model and token mix; channel fees included',
  'cond.goWindows': 'Per-5h/week/month caps',
  'cond.utilFull': 'full quota',
  'cond.utilHalf': 'half quota',
  'cond.utilQuarter': 'quarter quota',
  'cond.utilWeeks': '{u} · 4 wks',
  'score.pendingSplit': 'Mixed usage pending split',
  'score.noBenchmark': '{v}× equiv · no matching benchmark',
  'score.multiplier': '{v}× {basis}',
  'score.points': 'Score {v}',
  'score.estimate': 'source estimate',
  'record.referenceOnly': 'Reference only',
  'money.platform-budget': 'Included platform budget',
  'money.api-observation': 'Observed API equivalent',
  'money.retail-credit-value': 'Value at add-on price',
  'money.unit-cost': 'Unit cost',
  'money.api-unit-cost': 'Blended API price',
  'money.api-input-cost': 'API input price',
  'money.free': 'Free usage, cash paid',
  'money.contract': 'Contract and usage dependent',
  'money.variable': 'Variable usage; monetary measurement pending',
  'money.unit.month': 'per month',
  'money.unit.30 days': 'per 30 days',
  'money.unit.million': 'per million tokens',
  'money.unit.input-million': 'per million input tokens',
  'money.unit.platform-million': 'per million platform tokens',
  'money.unit.credit': 'per platform credit',
  'money.unit.request': 'per request',

  'record.referenceRatio': 'Original estimate {v}× (not adopted)',
  'score.discount': 'promo',
  'list.officialApi': 'Official API',
  'list.usageBased': 'Usage-based',
  'list.oneTime': 'One-time',
  'list.perMonth': ' / mo',
  'list.perYear': 'yr',
  'list.est': 'est.',
  'list.empty': 'No results match the current filters',
  'list.emptyHint': 'Try adjusting filters; past-due data stays in research records.',
  'list.clearFilters': 'Clear filters',
  'list.loadingRows': 'Loading data',
  'score.notListed': 'Not listed',
  'record.total': '{n} plans · {scenarios} multiplier scenarios',
  'record.review': 'Under review',
  'record.ended': 'Ended · original values',
  'record.waitlist': 'Existing users / waitlist',
  'record.upcoming': 'Announced plan',
  'record.variableQuota': 'Variable allowance',
  'record.apiRates': 'Per million tokens: input ${input} / output ${output}',
  'record.view': 'View all data for {plan} {model}',
  'record.note': 'Multipliers compare API value per $1; scores combine token efficiency and model capability.',
  'record.status': 'Data status',

  'score.notPublished': 'Not published',
  'score.noPublishedUsage': 'No published comparable usage',
  'pending.title': 'Existing plans and original research',
  'pending.count': '{n} plans with original records',
  'pending.intro': 'Original prices, research values, sources and dates remain available here, including studies awaiting recheck or superseded by official rates. Historical values are not presented as current ranking results.',
  'pending.checked': 'Last checked {date}',
  'pending.price': 'Last checked price',
  'pending.research': 'Original research multipliers',
  'research.historical': 'historical',
  'research.reviewHistory': 'Review history',
  'research.cachedRatio': 'Original cached multiplier',
  'research.cachedTokens': 'Original cached usage (million tokens)',
  'pending.view': 'View original records and sources for {plan}',
  'unknown.title': 'Plan data (no reliable multiplier yet)',
  'unknown.more': '{names} and {n} more',
  'unknown.intro': 'Pricing, features, models, and original sources are preserved; no multiplier is forced without reliable usage, and free plans are not shown as infinite.',
  'list.free': 'Free',
  'list.balancedNote': 'Geometric weighting of 60% per-dollar usage × 40% ability. The score is not a revenue multiple; original research is preserved.',
  'list.estimateNote': '* Multi-source estimates carry over the original research — see the dialog for scope and basis. Same-plan scenarios are not additive.',
  'list.scenarios': '{n} scenarios',
  'list.viewScenario': 'View {plan} {model} {label}',
  'list.viewPlan': 'View {plan}{models}',
  'dialog.method': 'Methodology',
  'dialog.compare': 'Scenario comparison',
  'dialog.methodTitle': 'How the value of a dollar is compared',
  'dialog.compareTitle': 'Compare conditions side by side',
  'dialog.close': 'Close dialog',
  'method.equivalent': 'same-model API equivalent',
  'method.p1': 'A 6× multiplier means each $1 paid buys at most the equivalent of $6 of official-API usage of the same model. It is a price multiplier — not a multiple of ability or output.',
  'method.scoreLabel': 'Score',
  'method.scoreFormula': '100 × usage percentile⁰·⁶ × ability percentile⁰·⁴',
  'method.scoreNote': 'Usage = usable tokens per dollar, ranked as a percentile across all quotes; ability = leaderboard rank percentile. 60/40 is a disclosed trade-off, not the only answer.',
  'method.rulesTitle': 'One ruler, open conditions',
  'method.rule1': 'Usage = quota ÷ provider blended rate (80/20 input/output, no cache); switch the cached scenario in filters.',
  'method.rule2': 'Ability = Agent Arena general-board rank percentile, conservative end; scores from different test environments are never mixed.',
  'method.rule3': 'Subscriptions are measured at the full-quota ceiling; weekly quotas convert over 4 weeks. Models and time slots on one plan are alternative scenarios — multipliers must not be summed.',
  'method.rule4': 'Multi-source estimates keep their original weights and are never recomputed; unverified promos, taxes, and FX fees are excluded.',
  'method.rule5': 'Scores compare only within the same category and scenario snapshot; budget, search, and filters do not change them.',
  'method.footnote': 'All plans and research stay visible. Review deadlines mark status without removing original values. Formula version official-equivalent-1.',
  'tabs.overview': 'Plan terms',
  'tabs.sources': 'Verification sources',
  'tabs.planInfo': 'Plan info',
  'sources.userImport': 'original research check',
  'sources.fetched': 'fetched',
  'sources.note': 'All verification sources for this record are listed. Expand the research details to see original samples, weights and calculations.',
  'detail.perDollar': 'per $1',
  'detail.apiEquivalent': '${v} same-model official-API value',
  'detail.monthlyAmortized': 'Monthly amortized',
  'detail.actualCost': 'Actual cost',
  'detail.byUsage': 'By actual usage',
  'detail.apiInputRate': 'Input · USD per million tokens',
  'detail.apiOutputRate': 'Output · USD per million tokens',
  'detail.perMonthSuffix': ' / mo',
  'detail.annualUpfront': 'Annual upfront',
  'detail.utilization': 'Utilization',
  'detail.usageBased': 'Usage-based',
  'detail.quotaPercent': '{n}% of quota',
  'detail.abilityRank': 'Ability rank',
  'detail.verifiedAt': 'Verified',
  'detail.validUntil': 'Valid until',
  'research.originalCheck': 'Original check',
  'research.range': 'Original range {lo}–{hi}× · confidence {c}',
  'research.sourcesWeights': 'Research sources and weights',
  'research.weight': 'weight {n}%',
  'research.monthlyEquivalent': '${v}/mo equivalent',
  'calc.basis': 'Calculation basis',
  'calc.paid': 'Amount paid',
  'calc.usableQuota': 'Usable quota',
  'calc.totalTokens': 'Total usable tokens',
  'calc.apiEquivalent': 'Official-API equivalent',
  'calc.sameMix': 'Same token mix, same model. 80% input, 20% output; {cache}. {window}',
  'calc.cached': '80% of input is cache-hit',
  'calc.noCache': 'no cache counted',
  'calc.windowLimit': 'Limited by the tightest quota window.',
  'action.compare': 'Add to compare',
  'action.visitOfficial': 'Visit official ↗',
  'unknown.callout': 'Pricing and terms for this plan.',
  'unknown.listPrice': 'List price',
  'unknown.quotaNotes': 'Quota notes',
  'unknown.perYear': 'yr',
  'unknown.perMonth': 'mo',
  'dialog.sharedWarning': 'These scenarios share a plan but are different usage modes — quotas and multipliers are not additive.',
  'status.title': 'Verification records',
  'status.publicJson': 'View public JSON ↗',
  'status.inDate': 'In-date plans',
  'status.sources': 'Sources',
  'status.pendingRecheck': 'Pending recheck',
  'status.lastUpdated': 'Last updated',
  'status.planSources': 'Plan sources and recheck deadlines',
  'status.apiUsage': 'API usage-based',
  'status.subFree': 'Subscription/free plan',
  'status.verified': 'verified',
  'status.inDateTag': 'In date',
  'status.recheckTag': 'Recheck',
  'status.viewSource': 'View source ↗',
  'bench.title': 'Model benchmarks',
  'bench.intro': 'Only same-board, same-harness comparisons; model version, source, and date preserved.',
  'bench.gotoBoard': 'Original leaderboard ↗',
  'bench.general': 'General',
  'bench.empty': 'No verified data in this category yet',
  'bench.frontendNote': 'Frontend needs its own source; WebDev scores are not carried over.',
  'bench.aaNote': 'Artificial Analysis can provide Coding and General; shown once ingested.',
  'bench.rank': 'Rank',
  'bench.modelVersion': 'Model / test version',
  'bench.score': 'Score',
  'bench.tested': 'Tested',
  'bench.source': 'Source',
  'bench.note': 'Board scores do not equal real serving quality. Different reasoning effort, harness, or model version is not the same service.',
  'lang.switch': '中文',
};
